import Hero from './components/Hero';
import TrustStatement from './components/TrustStatement';
import ServicesOverview from './components/ServicesOverview';
import VisualShowcase from './components/VisualShowcase';
import VisualIdentity from './components/VisualIdentity';
import TechnologyPartners from './components/TechnologyPartners';
import Process from './components/Process';
import LegalValueStatement from './components/LegalValueStatement';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <TrustStatement />
      <ServicesOverview />
      <VisualShowcase />
      <VisualIdentity />
      <TechnologyPartners />
      <Process />
      <LegalValueStatement />
      <CallToAction />
      <Footer />
    </div>
  );
}
